// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f087b2ed","453":"dea34f19","455":"801d6b24","977":"66787924"}[chunkId] + ".chunk.js";
};